<script lang="ts">
    import { onDestroy, onMount } from 'svelte'
    import PredictiveAdjust from '../PredictiveMode/PredictiveAdjust.svelte'
    import { getPredictiveState, watchPredictiveState } from '../PredictiveMode/predictive'

    // A breakthrough that can be applied to the plan (Predictive Mode), with the same Apply / Not now as the status
    // report. It is the athlete's own plan, so it is always for the signed-in athlete.
    let proposal: any = null
    let applying = false
    let fallback: ReturnType<typeof setTimeout> | null = null

    async function refresh(fresh = false) {
        const state = await getPredictiveState(fresh)
        proposal = state && state.enabled ? state.pending : null
    }

    // Applying recalculates the fitness history in the background; the server announces when it is done and the page
    // (the plan, its goal and signature) is read again. If no announcement arrives it reads again after a minute and a half.
    const finished = () => {
        if (!applying) return
        applying = false
        if (fallback) clearTimeout(fallback)
        window.location.reload()
    }
    // Tells the tab bar (a red dot on Program) that the question is answered.
    const answered = () => window.dispatchEvent(new CustomEvent('xert-breakthrough-answered'))
    function onApplied() {
        answered()
        applying = true
        if (fallback) clearTimeout(fallback)
        fallback = setTimeout(finished, 90000)
    }

    // @ts-ignore
    const channel = window.Xert?._userChannel
    let stopWatching = () => {}
    onMount(() => {
        refresh()
        channel?.bind('trickle_complete', finished)
        // A breakthrough processed while this page is open brings its proposal here without a reload.
        stopWatching = watchPredictiveState((state) => { if (!applying) proposal = state && state.enabled ? state.pending : null })
    })
    onDestroy(() => {
        stopWatching()
        channel?.unbind('trickle_complete', finished)
        if (fallback) clearTimeout(fallback)
    })
</script>

{#if proposal}
    <PredictiveAdjust part="proposal" predictive={{ proposal }} on:applied={onApplied} on:dismissed={() => { answered(); refresh(true) }} />
{/if}
